import { formatDate } from './adminModel';

export const AGENT_PHOTOS_INTRO =
  "Show agents' Microsoft 365 profile photos instead of initials. Vertolytics gets read-only access to profile photos only, approved by a Microsoft 365 admin.";

const STATES = {
  off: { badge: 'Off', tone: '', body: AGENT_PHOTOS_INTRO, actions: ['turnOn'] },
  pendingConsent: {
    badge: 'Waiting for approval',
    tone: 'b-warning',
    body: "A Microsoft 365 admin needs to approve read-only access to profile photos. If you're a Microsoft 365 admin, approve it yourself; otherwise copy the link and send it to one.",
    actions: ['approve', 'copy', 'check', 'turnOff'],
  },
  on: {
    badge: 'On',
    tone: 'b-good',
    body: 'Profile photos show instead of initials. They refresh every day. People without a photo, or with a blank, broken or tiny one, keep their initials.',
    actions: ['turnOff'],
  },
  approvalRemoved: {
    badge: 'Approval removed',
    tone: 'b-serious',
    body: 'Microsoft 365 no longer lets Vertolytics read profile photos, so the photos were deleted and initials show. A Microsoft 365 admin can approve again.',
    actions: ['approve', 'copy', 'check', 'turnOff'],
  },
};

/** What the Agent photos card shows for a GET settings/agent-photos answer (null while it loads or fails). */
export function agentPhotosView(settings) {
  if (!settings || settings.available === false) return { available: false, badge: null, tone: '', body: 'Not available on this deployment.', actions: [], meta: null };
  const state = STATES[settings.state] || STATES.off;
  let meta = null;
  if (settings.state === 'on' && settings.changedByName) meta = `Turned on by ${settings.changedByName}${settings.changedAt ? ` on ${formatDate(settings.changedAt)}` : ''}`;
  else if (settings.state === 'on' && settings.approvedAt) meta = `On since ${formatDate(settings.approvedAt)}`;
  if (settings.state === 'approvalRemoved' && settings.approvalRemovedAt) meta = `Approval removed on ${formatDate(settings.approvalRemovedAt)}`;
  return { available: true, badge: state.badge, tone: state.tone, body: state.body, actions: state.actions, meta };
}

const CALLBACK_MESSAGES = {
  consent_not_confirmed: "Microsoft hasn't confirmed the approval yet. It can take a few minutes; then select Check again.",
  access_denied: "The Microsoft 365 admin didn't approve access to profile photos.",
  expired_state: 'That approval link expired. Copy a new link.',
  used_state: "That approval link was already used. If photos aren't on, copy a new link.",
  invalid_state: "That approval link isn't valid. Copy a new link.",
  tenant_mismatch: 'Access was approved in a different Microsoft 365 organization.',
  turned_off: 'Agent photos were turned off before the approval finished. Turn them on again.',
};

/** The message after Microsoft sends the admin back (?agentPhotos=approved, or failed&reason=…); null without one. */
export function consentReturnMessage(search) {
  const params = new URLSearchParams(search || '');
  const result = params.get('agentPhotos');
  if (result === 'approved') return { tone: 'success', text: 'Agent photos are on. Photos appear after the first refresh, usually within a few minutes.' };
  if (result === 'failed') return { tone: 'error', text: CALLBACK_MESSAGES[params.get('reason')] || "The approval didn't finish. Try again." };
  return null;
}
